import { render, staticRenderFns } from "./DrawerMenuList.vue?vue&type=template&id=912abcd2&"
import script from "./DrawerMenuList.vue?vue&type=script&lang=js&"
export * from "./DrawerMenuList.vue?vue&type=script&lang=js&"
import style0 from "./DrawerMenuList.vue?vue&type=style&index=0&id=912abcd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports